import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment-timezone';

@Component({
	selector: 'app-alert-label',
	templateUrl: './alert-label.component.html',
	styleUrls: ['./alert-label.component.scss'],
})
export class AlertLabelComponent implements OnInit {
	@Input() changedFinancialTypeAt: string;
	public professionalWillBecomePjAt;
	public PJMonthValidity;
	public professionalShouldChangeFinancialDataAt;
	public professionalShouldSendNFAfter;
	ngOnInit(): void {
		let date = moment.utc(this.changedFinancialTypeAt).add(1, 'day');
		date = moment(date).date(24);

		this.professionalWillBecomePjAt = date.format('DD/MM');
		this.PJMonthValidity = moment(date).format('MMM');
		this.professionalShouldChangeFinancialDataAt = date
			.date(7)
			.add(1, 'month')
			.format('DD/MM');
		this.professionalShouldSendNFAfter = date.date(25).format('DD/MM');
	}
}
